// extracted by mini-css-extract-plugin
module.exports = {"available-translations":"AddTranslation_available-translations__mr69i"};